import YearPicker from "../YearPicker";
import type { HandleInputChange } from "./types";

type YearInputProps = {
    name: string;
    value?: string | number;
    future?: boolean;
    onChange: HandleInputChange;
};

const YearInput = ({ name, value, future = false, onChange }: YearInputProps) => {
    return (
        <YearPicker
            name={name}
            value={value}
            future={future}
            onChange={onChange}
        />
    );
};

export default YearInput;
